import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

// Common Fragments
import {
	AddedCompensationFragment,
	CallActivityPerformanceFragment,
	ChargebacksFragment,
	CompensationFragment,
	EmployeeFragment,
	LongevityFragment,
	ReviewFragment,
	TechnicianSpiffsFragment,
} from "@/Washouts/api/common/fragments";
import { AdvisorsStoreMetricsFragment, PerformanceFragment } from "./fragments";

const getAdvisorsWashout = async (...params: string[]) => {
	const [location, userId, commissionCycleId, payPeriodId, position] = params;

	const query = gql`
		query getAdvisorsWashout(
			$locationId: String!
			$userId: String!
			$commissionCycleId: String!
			$payPeriodId: String!
			$position: String!
		) {
			getAdvisorsWashout(
				locationId: $locationId
				userId: $userId
				commissionCycleId: $commissionCycleId
				payPeriodId: $payPeriodId
				position: $position
			) {
				_id
				userId
				commissionCycleId
				payPeriodId
				created
				employee {
					...Employee
				}
				spiffs {
					...Spiffs
				}
				longevity {
					...Longevity
				}
				review {
					...Review
				}
				performance {
					...Performance
				}
				callActivityPerformance {
					...WashoutCallActivityPerformance
				}
				storeMetrics {
					...AdvisorsStoreMetrics
				}
				addedCompensations {
					...AddedCompensation
				}
				summary {
					...Compensation
				}
				chargebacks {
					...Chargebacks
				}
				effectiveLaborRate
				averageHoursPerRepairOrder
				followUpPerformance {
					averageTimeSinceLastContact
					averageClosedRepairOrdersPerDay
				}
			}
		}
		${AddedCompensationFragment}
		${AdvisorsStoreMetricsFragment}
		${CallActivityPerformanceFragment}
		${ChargebacksFragment}
		${CompensationFragment}
		${EmployeeFragment}
		${LongevityFragment}
		${PerformanceFragment}
		${ReviewFragment}
		${TechnicianSpiffsFragment}
	`;

	const variables = {
		locationId: location,
		commissionCycleId,
		userId,
		payPeriodId,
		position,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getAdvisorsWashout;
	} catch (error) {
		errorLogger(error as Error);
		return null;
	}
};

async function getAdvisorsWashoutReview(...params: string[]) {
	const [location, commissionCycle, payPeriodId = null, position] = params;
	const query = gql`
		query getAdvisorsWashout($locationId: String!, $commissionCycleId: String!, $payPeriodId: String, $position: String!) {
			getAdvisorsWashout(
				commissionCycleId: $commissionCycleId
				locationId: $locationId
				payPeriodId: $payPeriodId
				position: $position
			) {
				_id
				review {
					...Review
				}
			}
		}
		${ReviewFragment}
	`;
	const variables = {
		locationId: location,
		commissionCycleId: commissionCycle,
		payPeriodId,
		position,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getAdvisorsWashout;
	} catch (error) {
		errorLogger(error as Error);
		return null;
	}
}

export { getAdvisorsWashout, getAdvisorsWashoutReview };
